"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateNameMinorChange = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var react_redux_1 = require("react-redux");
var ajax_util_1 = require("../../../utils/ajax/ajax.util");
var constants_1 = require("../../../constants");
var ROUTES = constants_1.default.ROUTES, VIEWS = constants_1.default.VIEWS;
var name_1 = require("../../../actions/name");
var commonweb_utils_1 = require("commonweb-utils");
var pp_react_1 = require("@paypalcorp/pp-react");
var interpolate_1 = require("../../../utils/interpolate/interpolate");
var interpolate_component_1 = require("../../../components/interpolate-component");
var page = require("page");
var UpdateNameMinorChange = /** @class */ (function (_super) {
    tslib_1.__extends(UpdateNameMinorChange, _super);
    function UpdateNameMinorChange(props) {
        var _this = _super.call(this, props) || this;
        _this.inputChangedHandler = function (event, inputIdentifier) {
            _this.setState({ errorMessage: "" });
            var updatedForm = tslib_1.__assign({}, _this.state.form);
            var updatedFormElement = tslib_1.__assign({}, updatedForm[inputIdentifier]);
            updatedFormElement.value = event.target.value;
            updatedFormElement.isValid = true;
            updatedFormElement.isTouched = true;
            updatedFormElement.blankFieldError = "";
            updatedForm[inputIdentifier] = updatedFormElement;
            var formIsValid = true;
            for (var inputIdentifier_1 in updatedForm) {
                formIsValid = updatedForm[inputIdentifier_1].isValid && formIsValid;
            }
            _this.setState({
                form: updatedForm,
                formIsValid: formIsValid,
                errorMessage: "",
                showValidationErrorMessage: false,
            });
        };
        _this.submitHandler = function (event) {
            event.preventDefault();
            var formData = {};
            for (var formElementIdentifier in _this.state.form) {
                formData[formElementIdentifier] = _this.state.form[formElementIdentifier].value;
            }
            if (_this.state.consent != true) {
                _this.setState({
                    errorMessage: _this.nameContent.error.legalDisclaimer,
                });
            }
            else {
                if (_this.checkValidity(formData)) {
                    _this.setState({ showSpinner: true });
                    ajax_util_1.default.post$(_this.props.dispatch, _this.props._csrf, "" + ROUTES.API.NAME.MINOR_UPDATE, formData, { component: { name: VIEWS.UPDATE_NAME_SUCCESS } })
                        .then(function (_) {
                        _this.props.dispatchNameChange({
                            firstName: formData["firstName"],
                            lastName: formData["lastName"],
                        });
                        page.redirect(constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.NAME.UPDATE_SUCCESS);
                    })
                        .catch(function (error) {
                        var errorStatusCode = commonweb_utils_1.objectUtils.safeGet(error, "error.statusCode") || 500;
                        if (errorStatusCode >= 400 && errorStatusCode < 500) {
                            _this.setState({
                                showValidationErrorMessage: true,
                            });
                        }
                        else {
                            _this.setState({
                                errorMessage: _this.props.content.common
                                    .genericServerError,
                                showValidationErrorMessage: false,
                            });
                        }
                        _this.setState({ showSpinner: false });
                        return;
                    });
                }
            }
        };
        _this.nameContent = _this.props.content.name;
        var layout = commonweb_utils_1.objectUtils.safeGet(_this.props.name, "metadata.layout") || [];
        _this.state = {
            consent: false,
            form: {
                firstName: {
                    elementType: "input",
                    elementConfig: {
                        type: "text",
                        placeholder: _this.nameContent.firstName.label,
                        suggestionText: _this.nameContent.name.error,
                    },
                    value: "",
                    validation: {
                        required: layout.find(function (key) {
                            return key.$ === "givenName" && key.required === true;
                        })
                            ? true
                            : false,
                    },
                    isValid: false,
                    isTouched: false,
                    blankFieldError: "",
                },
                lastName: {
                    elementType: "input",
                    elementConfig: {
                        type: "text",
                        placeholder: _this.nameContent.lastName.label,
                        suggestionText: _this.nameContent.name.error,
                    },
                    value: "",
                    validation: {
                        required: layout.find(function (key) {
                            return key.$ === "surname" && key.required === true;
                        })
                            ? true
                            : false,
                    },
                    isValid: false,
                    isTouched: false,
                    blankFieldError: "",
                },
            },
            formIsValid: false,
            errorMessage: "",
            showValidationErrorMessage: false,
            showSpinner: false,
        };
        return _this;
    }
    UpdateNameMinorChange.prototype.handleCheckboxChange = function (event) {
        var isChecked = event.target.checked;
        this.setState({
            consent: isChecked,
            errorMessage: "",
            showValidationErrorMessage: false,
        });
    };
    UpdateNameMinorChange.prototype.checkValidity = function (formData) {
        var isValid = true, commonContent = this.props.content.common, updatedForm = this.state.form, firstNameFormElement = updatedForm["firstName"], lastNameFormElement = updatedForm["lastName"];
        if (firstNameFormElement &&
            firstNameFormElement.validation.required &&
            formData["firstName"].trim() === "") {
            firstNameFormElement.blankFieldError =
                commonContent.genericBlankFieldError;
            this.setState({ form: updatedForm });
            isValid = false;
        }
        if (lastNameFormElement &&
            lastNameFormElement.validation.required &&
            formData["lastName"].trim() === "") {
            lastNameFormElement.blankFieldError =
                commonContent.genericBlankFieldError;
            this.setState({ form: updatedForm });
            isValid = false;
        }
        if (formData["firstName"] === this.props.name.firstName &&
            formData["lastName"] === this.props.name.lastName) {
            // Until L10N values are corrected temporarily full name is a part of first name.
            this.setState({ errorMessage: this.nameContent.error.sameName });
            isValid = false;
        }
        return isValid;
    };
    UpdateNameMinorChange.prototype.render = function () {
        var _this = this;
        var cancelLink, isFlow = this.props.route.isFlow || false, flowName = this.props.route.enter.flow || "", nameFpti = this.props.nameFpti;
        if (isFlow) {
            cancelLink = constants_1.default.BASE_URI + "/flow-return/" + flowName;
        }
        else {
            cancelLink = "" + constants_1.default.BASE_URI;
        }
        var formElementsArray = [];
        for (var key in this.state.form) {
            formElementsArray.push({
                id: key,
                config: this.state.form[key],
            });
        }
        var form = (React.createElement("form", { onSubmit: this.submitHandler },
            React.createElement(pp_react_1.Text, { size: "xl3", className: "name-header" }, this.nameContent.minor.title),
            this.state.showValidationErrorMessage !== true ? (React.createElement(pp_react_1.Alert, { type: "attention", className: "alignLeft nameAlert" }, this.nameContent.change.instruction.label)) : null,
            this.state.errorMessage ? (React.createElement(pp_react_1.Alert, { type: "error", className: "alignLeft nameAlert" }, this.state.errorMessage)) : null,
            this.state.showValidationErrorMessage ? (React.createElement(pp_react_1.Alert, { type: "error", className: "alignLeft nameAlert" }, this.props.validationErrorComponent)) : null,
            React.createElement(pp_react_1.Text, { size: "md", className: "alignLeft name-sub-header" },
                React.createElement("span", { dangerouslySetInnerHTML: this.props.currentNameComponent })),
            formElementsArray.map(function (formElement) { return (React.createElement(pp_react_1.TextInput, { key: formElement.id, id: formElement.id, value: formElement.config.value, name: formElement.id, label: formElement.config.elementConfig.placeholder, className: "alignLeft name-text-input", disabled: _this.state.showSpinner, onChange: function (event) {
                    return _this.inputChangedHandler(event, formElement.id);
                }, errorText: _this.state.form[formElement.id].blankFieldError })); }),
            // @ts-ignore
            React.createElement(pp_react_1.Checkbox, { disabled: this.state.showSpinner, label: this.nameContent.legalDisclaimer, id: "consent", name: "consent", onChange: function (event) { return _this.handleCheckboxChange(event); } }),
            React.createElement(pp_react_1.Button, { type: "submit", name: nameFpti.submit, className: "nameUpdateButton", disabled: this.state.showSpinner }, this.state.showSpinner ? (React.createElement(pp_react_1.LoadingSpinner, { className: "loading-spinner", screenReaderText: "loading", inverse: true })) : (React.createElement(pp_react_1.Text, { size: "md", medium: true }, this.nameContent.change.button.label))),
            React.createElement(pp_react_1.Link, { href: cancelLink, "data-name": nameFpti.cancel, target: "_self", className: "test_cancel nameCancelButton fiActionResult-secondaryActions", onClick: this.props.transitionOutHandler },
                React.createElement(pp_react_1.Text, { size: "md", medium: true }, this.props.content.common.cancel))));
        return React.createElement("div", { className: "generic-container" }, form);
    };
    return UpdateNameMinorChange;
}(React.Component));
exports.UpdateNameMinorChange = UpdateNameMinorChange;
var mapStateToProps = function (_a) {
    var _csrf = _a._csrf, ui = _a.ui, content = _a.content, route = _a.route, links = _a.links, account = _a.account, fpti = _a.fpti;
    var name = commonweb_utils_1.objectUtils.safeGet(account, "name") || {};
    var nameFpti = fpti.nameChange;
    var nameContent = content.name;
    var firstname = name.firstName;
    var lastname = name.lastName;
    var currentNameComponent = {
        __html: interpolate_1.default("inDoubleQuotedAttr", nameContent.currentName.label, {
            firstname: firstname,
            lastname: lastname,
        }),
    }, otherNameChangeOptionsUrl = links.otherNameChangeOptionsUrl.linkUrl, otherNameChangeOptionsComponent = (React.createElement(pp_react_1.Link, { "data-name": nameFpti.otherOptionsLink, key: nameContent.otherOptionsLink, href: otherNameChangeOptionsUrl }, nameContent.otherOptionsLink)), validationErrorComponent = interpolate_component_1.InterpolateLinksWithComponent(nameContent.higherChangeCount.alert, [otherNameChangeOptionsComponent]);
    return {
        _csrf: _csrf,
        ui: ui,
        content: content,
        route: route,
        name: name,
        currentNameComponent: currentNameComponent,
        validationErrorComponent: validationErrorComponent,
        nameFpti: nameFpti,
    };
};
function mapDispatchToProps(dispatch) {
    return {
        dispatchNameChange: function (nameInfo) { return dispatch(name_1.changeName(nameInfo)); },
        dispatch: dispatch,
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(UpdateNameMinorChange);
